// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type DeleteEpmMasterVddMutationVariables = Types.Exact<{
  deleteEpmMasterVddId: Types.Scalars['ID']['input'];
}>;

export type DeleteEpmMasterVddMutation = { __typename?: 'Mutation' } & Pick<Types.Mutation, 'deleteEpmMasterVdd'>;

export const DeleteEpmMasterVddDocument = /*#__PURE__*/ gql`
    mutation DeleteEpmMasterVdd($deleteEpmMasterVddId: ID!) {
  deleteEpmMasterVdd(id: $deleteEpmMasterVddId)
}
    `;
export type DeleteEpmMasterVddMutationFn = Apollo.MutationFunction<
  DeleteEpmMasterVddMutation,
  DeleteEpmMasterVddMutationVariables
>;

/**
 * __useDeleteEpmMasterVddMutation__
 *
 * To run a mutation, you first call `useDeleteEpmMasterVddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEpmMasterVddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEpmMasterVddMutation, { data, loading, error }] = useDeleteEpmMasterVddMutation({
 *   variables: {
 *      deleteEpmMasterVddId: // value for 'deleteEpmMasterVddId'
 *   },
 * });
 */
export function useDeleteEpmMasterVddMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteEpmMasterVddMutation, DeleteEpmMasterVddMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteEpmMasterVddMutation, DeleteEpmMasterVddMutationVariables>(
    DeleteEpmMasterVddDocument,
    options,
  );
}
export type DeleteEpmMasterVddMutationHookResult = ReturnType<typeof useDeleteEpmMasterVddMutation>;
export type DeleteEpmMasterVddMutationOptions = Apollo.BaseMutationOptions<
  DeleteEpmMasterVddMutation,
  DeleteEpmMasterVddMutationVariables
>;
